import React from "react";
/* asset imports */
import fatsCart from "../assets/images/fats/fats-cart.png";

const HealthyFatsCart = ({ handleCartClick }) => {
  return (
    <div className="fats-cart" onClick={() => handleCartClick(2)}>
      <img src={fatsCart} alt="" />
    </div>
  );
};

export default HealthyFatsCart;
